import { render } from "./certificate.vue?vue&type=template&id=7d50eeb6"
import script from "./certificate.vue?vue&type=script&lang=js"
export * from "./certificate.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/vueComponents/admin/certificate.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7d50eeb6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7d50eeb6', __exports__)) {
    api.reload('7d50eeb6', __exports__)
  }
  
  module.hot.accept("./certificate.vue?vue&type=template&id=7d50eeb6", () => {
    api.rerender('7d50eeb6', render)
  })

}


export default __exports__